import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../_common/Table";
import TitleBar from "../_common/TitleBar";
import AlertModal from "../_common/AlertModal";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import payEstimateDetailTitleBarMenu from "../_titleBarMenus/payEstimateDetailTitleBarMenu";
import { actionScripts } from "../../_helpers/actionScripts";
import payEstimateActions from "../../_actions/payEstimateActions";
import qSheetActions from "../../_actions/qSheetActions";
import bidItemActions from "../../_actions/bidItemActions";
import "./payEstimate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EstimateDetailModal from "./EstimateDetailModal";


// ── Status badge config ──────────────────────────────────────────────────────

const QSHEET_STATUS_BADGE = {
  Draft:      { cls: "bg-dark",    label: "Draft" },
  Calculated: { cls: "bg-primary", label: "Calculated" },
  Checked:    { cls: "bg-success", label: "Checked" },
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric", month: "short", day: "numeric",
  });
};

// ── Component ────────────────────────────────────────────────────────────────

class PayEstimateDetail extends Component {
  state = {
    sortColumn: { path: "itemNo", order: "asc" },
    selectedQSheetId: null,

    // QSheet list filter
    qSheetFilter: "all",    // "all" | "roadway" | "structure"

    // Delete confirmation
    pendingDeleteId: null,

    // Close estimate confirmation
    showCloseConfirm: false,

    // CreateQSheetModal state
    showCreateModal: false,
    activeTab: "all",       // "all" | "dow" | "reports"
    dowFilter: "roadway",   // "roadway" | "structure"
    selectedBidItem: null,
    createError: null,

    // Estimate Detail (CEM-6101) modal
    showEstimateDetailModal: false,
    estimateDetailValues: {},
  };

  componentDidMount() {
    const { tab, projItemList, dispatch, userId } = this.props;
    dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId));
    dispatch(payEstimateActions.fetchReportedItems(tab.docId, tab.tabId));
    if (!projItemList) {
      dispatch(bidItemActions.getAll(tab.projectId));
    }
    dispatch(payEstimateActions.prepopulateQSheets(tab.docId, userId, tab.tabId))
      .then(() => dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId)))
      .catch(() => {});
  }

  handleCloseEstimateAction = (action) => () => {
    if (action === "accept") {
      const { tab, userId, dispatch } = this.props;
      dispatch(payEstimateActions.closeEstimate(tab.docId, userId, tab.tabId))
        .then(() => dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId)))
        .catch(() => {});
    }
    this.setState({ showCloseConfirm: false });
  };

  handleDeleteAction = (action) => () => {
    if (action === "accept") {
      this.props.dispatch(qSheetActions.deleteQSheet(this.state.pendingDeleteId, null));
    }
    this.setState({ pendingDeleteId: null });
  };

  handleRefreshReportedItems = () => {
    const { tab, dispatch, userId } = this.props;
    dispatch(payEstimateActions.fetchReportedItems(tab.docId, tab.tabId));
    dispatch(payEstimateActions.prepopulateQSheets(tab.docId, userId, tab.tabId))
      .then(() => dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId)))
      .catch(() => {});
  };

  componentWillUnmount() {
    const { tab, dispatch } = this.props;
    dispatch({ type: "PE.CLOSE_TAB", tabId: tab.tabId });
  }

  // ── Table columns ──────────────────────────────────────────────────────────

  columns = [
    {
      path: "itemNo",
      label: "No.",
      disableSort: true,
      content: (qs) => qs.itemNo,
      thClassName: "pe-detail-col--itemNo",
      tdClassName: "pe-detail-col--itemNo",
    },
    {
      path: "description",
      disableSort: true,
      label: "Description",
      content: (qs) => (
        <>
          {qs.description}
          {/*{qs.isStructuresItem && (
            <span className="badge badge-warning mr-1">Str</span>
          )}*/}
        </>
      ),
      thClassName: "pe-detail-col--desc",
      tdClassName: "pe-detail-col--desc",
    },
    {
      key: "unitPrice",
      label: "Unit Price",
      disableSort: true,
      content: (qs) => {
        const item = (this.props.projItemList || []).find((i) => i.bidItemId === qs.bidItemId);
        return item?.bidUnitPrice != null
          ? item.bidUnitPrice.toLocaleString("en-US", { style: "currency", currency: "USD" })
          : <span className="text-muted">—</span>;
      },
      thClassName: "pe-detail-col--unitPrice",
      tdClassName: "pe-detail-col--unitPrice",
    },
    {
      key: "totalQuantity",
      label: "Auth. Qty",
      disableSort: true,
      content: (qs) => {
        const item = (this.props.projItemList || []).find((i) => i.bidItemId === qs.bidItemId);
        if (!item) return <span className="text-muted">—</span>;
        return parseFloat(((item.eeQuantity || 0) + (item.ccoQuantity || 0)).toFixed(3));
      },
      thClassName: "pe-detail-col--sheetNo",
      tdClassName: "pe-detail-col--sheetNo",
    },
    {
      path: "quantityPaidToDate",
      label: "Paid To Date",
      disableSort: true,
      content: (qs) =>
        qs.quantityPaidToDate != null
          ? parseFloat(qs.quantityPaidToDate.toFixed(3))
          : <span className="text-muted">—</span>,
      thClassName: "pe-detail-col--paidToDate",
      tdClassName: "pe-detail-col--paidToDate",
    },
    {
      path: "totalEstimatedQuantity",
      label: "Pay Qty",
      disableSort: true,
      content: (qs) => {
        if (qs.totalEstimatedQuantity == null) return <span className="text-muted">—</span>;
        const qty = parseFloat(qs.totalEstimatedQuantity.toFixed(3));
        return qs.unitOfMeasure ? `${qty} ${qs.unitOfMeasure}` : qty;
      },
      thClassName: "pe-detail-col--amount",
      tdClassName: "pe-detail-col--amount",
    },
    {
      key: "totalPayDollars",
      label: "Pay Amount $",
      disableSort: true,
      content: (qs) => {
        const item = (this.props.projItemList || []).find((i) => i.bidItemId === qs.bidItemId);
        if (qs.totalEstimatedQuantity == null || item?.bidUnitPrice == null)
          return <span className="text-muted">—</span>;
        return (qs.totalEstimatedQuantity * item.bidUnitPrice)
          .toLocaleString("en-US", { style: "currency", currency: "USD" });
      },
      thClassName: "pe-detail-col--amount",
      tdClassName: "pe-detail-col--amount",
    },
    {
      path: "statusLabel",
      label: "Status",
      disableSort: true,
      content: (qs) => {
        const badge = QSHEET_STATUS_BADGE[qs.statusLabel] ?? QSHEET_STATUS_BADGE.Draft;
        return (
          <span className={`span-bubble p-1 px-2 ${badge.cls}`}>
            {badge.label}
          </span>
        );
      },
      thClassName: "pe-detail-col--status",
      tdClassName: "pe-detail-col--status",
    },
    // {
    //   path: "sourceId",
    //   label: "Source ID",
    //   disableSort: true,
    //   content: (qs) => qs.sourceId
    //     ? <span className="text-monospace small">{qs.sourceId}</span>
    //     : <span className="text-muted">—</span>,
    //   thClassName: "pe-detail-col--sourceId",
    //   tdClassName: "pe-detail-col--sourceId",
    // },
    {
      key: "delete",
      label: "",
      disableSort: true,
      content: (qs) => (
        <button
          className="btn btn-sm btn-outline-danger py-0 px-1"
          title="Delete QSheet"
          onClick={(e) => {
            e.stopPropagation();
            this.setState({ pendingDeleteId: qs.qSheetId });
          }}
        >
          <span style={{ color: "red", fontWeight: "bold" }}>✕</span>
        </button>
      ),
      thClassName: "pe-detail-col--del",
      tdClassName: "pe-detail-col--del",
    },
  ];

  // ── TitleBar handler (curried) ─────────────────────────────────────────────

  handleTitleBarAction = (action) => () => {
    const { tab, estimateDetail, userId, dispatch } = this.props;
    const isClosed = estimateDetail?.isClosed ?? tab?.isClosed ?? false;
    switch (action) {
      case "newQSheet":
        if (!isClosed) this.setState({ showCreateModal: true, selectedBidItem: null });
        break;
      case "refresh":
        dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId));
        break;
      case "closeEstimate":
        if (!isClosed && window.confirm("Close this estimate? No new QSheets can be added after closing.")) {
          dispatch(payEstimateActions.closeEstimate(tab.docId, userId, tab.tabId));
        }
        break;
      case "closeTab":
        break;
      default:
        break;
    }
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleRowClick = (qSheet) => {
    this.setState({ selectedQSheetId: qSheet.qSheetId });
    const { tab, estimateDetail } = this.props;
    const isClosed = estimateDetail?.isClosed ?? tab?.isClosed ?? false;
    actionScripts.OPEN_QSHEET.run(
      qSheet,
      tab?.estimateNumber,
      tab?.projectId,
      tab?.payPeriod?.startDate,
      tab?.payPeriod?.endDate,
      isClosed
    );
  };

  handleCreateSubmit = () => {
    const { selectedBidItem } = this.state;
    const { tab, userId, dispatch } = this.props;
    if (!selectedBidItem) return;
    const dto = {
      payEstimateId: tab.docId,
      bidItemId: selectedBidItem.value,
      createdByUserId: userId,
    };
    dispatch(qSheetActions.createQSheet(dto, tab.tabId))
      .then(() => {
        dispatch(payEstimateActions.fetchDetail(tab.docId, tab.tabId));
        this.setState({ showCreateModal: false, selectedBidItem: null, createError: null });
      })
      .catch((err) => {
        const msg = err?.response?.data || "A Q-Sheet for this bid item already exists on this estimate.";
        this.setState({ createError: typeof msg === "string" ? msg : "A Q-Sheet for this bid item already exists on this estimate." });
      });
  };

  // ── Bid item options for the active tab ────────────────────────────────────

  getBidItemOptions = () => {
    const { activeTab, dowFilter } = this.state;
    const { projItemList } = this.props;

    if (!projItemList) return [];

    const byItemNo = (a, b) =>
      String(a.itemNo ?? "").localeCompare(String(b.itemNo ?? ""), undefined, { numeric: true });

    const toOption = (i) => ({
      value: i.bidItemId,
      label: i.itemListCaption,
    });

    if (activeTab === "dow") {
      if (dowFilter === "structure")
        return [...projItemList]
          .filter((i) => (i.dowStructureQuantity || 0) > 0)
          .sort(byItemNo)
          .map(toOption);
      // roadway (district)
      return [...projItemList]
        .filter((i) => {
          const total = (i.eeQuantity || 0) + (i.ccoQuantity || 0);
          return total - (i.dowStructureQuantity || 0) > 0;
        })
        .sort(byItemNo)
        .map(toOption);
    }

    // "all"
    return [...projItemList].sort(byItemNo).map(toOption);
  };

  // ── Render ─────────────────────────────────────────────────────────────────

  render() {
    const {
      sortColumn,
      selectedQSheetId,
      qSheetFilter,
      pendingDeleteId,
      showCloseConfirm,
      showCreateModal,
      activeTab,
      dowFilter,
      selectedBidItem,
      createError,
      showEstimateDetailModal,
      estimateDetailValues,
    } = this.state;

    const { tab, estimateDetail, reportedItems, projItemList, fetching, prepopulatingQSheets } = this.props;

    if (!estimateDetail && fetching) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
          <FontAwesomeIcon icon="spinner" spin size="2x" className="text-secondary" />
        </div>
      );
    }

    const isClosed       = estimateDetail?.isClosed ?? tab?.isClosed ?? false;
    const estimateNumber = estimateDetail?.estimateNumber ?? tab?.estimateNumber ?? "?";
    const startDate      = formatDate(estimateDetail?.payPeriodStartDate ?? tab?.payPeriod?.startDate);
    const endDate        = formatDate(estimateDetail?.payPeriodEndDate ?? tab?.payPeriod?.endDate);
    const qSheets        = estimateDetail?.qSheets ?? [];
    const bidItemOptions = this.getBidItemOptions();


    const byItemNo = (a, b) => (a.itemNo ?? 0) - (b.itemNo ?? 0);
    const sortedSheets = [...qSheets].sort(byItemNo);

    // DoW-based helpers using projItemList when available
    const dowMap = projItemList
      ? Object.fromEntries(projItemList.map((i) => [i.bidItemId, i]))
      : null;

    // Use dowStructureQuantity (DoW tab) as primary source; fall back to
    // totalStructureQuantity (per-location modal sum) when DoW tab is unset.
    const getEffectiveStrQty = (item) => {
      const dow = item.dowStructureQuantity || 0;
      return dow > 0 ? dow : (item.totalStructureQuantity || 0);
    };

    const dowHasStructure = (qs) => {
      const item = dowMap?.[qs.bidItemId];
      if (!item) return qs.isStructuresItem;
      return getEffectiveStrQty(item) > 0;
    };
    const dowHasRoadway = (qs) => {
      const item = dowMap?.[qs.bidItemId];
      if (!item) return !qs.isStructuresItem;
      const total = (item.eeQuantity || 0) + (item.ccoQuantity || 0);
      // > 0.001 tolerance to guard against JS floating-point imprecision
      // when eeQty + ccoQty is computed slightly larger than the stored decimal
      return total - getEffectiveStrQty(item) > 0.001;
    };
    const dowIs100PctStructure = (qs) => {
      const item = dowMap?.[qs.bidItemId];
      if (!item) return false;
      const total = (item.eeQuantity || 0) + (item.ccoQuantity || 0);
      if (total <= 0) return false;
      // roadway portion < 0.001 → treat as 100% structure (float tolerance)
      return total - getEffectiveStrQty(item) < 0.001;
    };

    const filteredSheets = qSheetFilter === "roadway"
      ? sortedSheets.filter(dowHasRoadway)
      : qSheetFilter === "structure"
        ? sortedSheets.filter(dowHasStructure)
        : sortedSheets;

    const getQSheetRowClassName = (qs) =>
      dowIs100PctStructure(qs) ? "table-warning" : "";

    const nonDraftSheets  = qSheets.filter((qs) => !qs.isDraft);
    const totalPayAmount  = nonDraftSheets.reduce((s, qs) => {
      const item = projItemList?.find((i) => i.bidItemId === qs.bidItemId);
      return s + (qs.totalEstimatedQuantity || 0) * (item?.bidUnitPrice || 0);
    }, 0);
    const totalPaidToDate = estimateDetail?.estimatePaidToDate ?? 0;

    const disabledActions = { newQSheet: isClosed };

    return (
      <React.Fragment>

        {/* ── TitleBar ──────────────────────────────────────────────── */}
        <TitleBar
          titleText={`Pay Estimate #${estimateNumber}`}
          menu={payEstimateDetailTitleBarMenu}
          handleTitleBarAction={this.handleTitleBarAction}
          disabledActions={disabledActions}
        />

        {/* ── Estimate summary header ───────────────────────────────── */}
        <div className="card m-2">
          <div className="card-body py-2">

            {/* Single row: badge + pay period + totals */}
            <div className="d-flex align-items-center flex-wrap">
              <span
                className={`span-bubble p-1 px-2 mr-4 flex-shrink-0 ${
                  isClosed ? "bg-secondary" : "bg-primary"
                }`}
              >
                {isClosed ? "Closed" : "Open"}
              </span>
              {/* <Button
                size="sm"
                color="secondary"
                outline
                onClick={() => this.setState({ showEstimateDetailModal: true })}
              >
                Project Record - Estimate Request (CEM-6101)
              </Button> */}
              <div className="mr-4">
                <small className="text-muted d-block">Pay Period Begin</small>
                <span>{startDate}</span>
              </div>
              <div className="mr-4">
                <small className="text-muted d-block">Pay Period End</small>
                <span>{endDate}</span>
              </div>
              <div className="ml-auto d-flex">
                <div className="text-right mr-4">
                  <small className="text-muted d-block">Total Pay This Estimate</small>
                  <strong>{totalPayAmount.toLocaleString("en-US", { style: "currency", currency: "USD" })}</strong>
                </div>
                <div className="text-right">
                  <small className="text-muted d-block">Estimate Paid To Date</small>
                  <strong>{totalPaidToDate.toLocaleString("en-US", { style: "currency", currency: "USD" })}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── QSheet list ───────────────────────────────────────────── */}
        <div className="card m-2">
          <div className="card-body">
            {/* Header row: title + filter + sync */}
            <div className="d-flex align-items-center mb-2">
              <h5 className="mb-0 mr-3">Q-Sheet List</h5>
              {prepopulatingQSheets && (
                <span className="text-secondary mr-3">
                  <FontAwesomeIcon icon="spinner" spin className="mr-1" />
                  Generating Q-Sheets...
                </span>
              )}
              <ButtonGroup size="sm">
                <Button outline color="secondary" active={qSheetFilter === "all"}
                  onClick={() => this.setState({ qSheetFilter: "all" })}>All</Button>
                <Button outline color="secondary" active={qSheetFilter === "roadway"}
                  onClick={() => this.setState({ qSheetFilter: "roadway" })}>Roadway</Button>
                <Button outline color="secondary" active={qSheetFilter === "structure"}
                  onClick={() => this.setState({ qSheetFilter: "structure" })}>Structure</Button>
              </ButtonGroup>
              {!isClosed && (
                <Button
                  color="secondary"
                  size="sm"
                  outline
                  className="ml-auto"
                  disabled={prepopulatingQSheets}
                  title="Pull in any newly reported items as Q-Sheets"
                  onClick={this.handleRefreshReportedItems}
                >
                  <FontAwesomeIcon icon={prepopulatingQSheets ? "spinner" : "sync-alt"} spin={prepopulatingQSheets} className="mr-1" />
                  Sync Reported Items
                </Button>
              )}
            </div>

            {/* QSheet table */}
            <div className="payEstimate-table-container border mb-3">
              <Table
                className="table table-hover pe-detail-table w-100"
                data={filteredSheets}
                idPropName="qSheetId"
                selectedItemId={selectedQSheetId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleRowClick}
                getRowClassName={getQSheetRowClassName}
              />
            </div>

            <div className="d-flex align-items-center mt-2">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon="plus" className="mr-2" />
                <b>Add Q-Sheet</b>
              </button>
              {!isClosed && (
                <>
                  <button
                    className="btn btn-success ml-auto"
                    type="button"
                    onClick={() => this.setState({ showCloseConfirm: true })}
                  >
                    <FontAwesomeIcon icon="lock" className="mr-2" />
                    <b>Lock Pay Estimate</b>
                  </button>
                </>
              )}
            </div>

          </div>
        </div>

        {/* ── Create QSheet Modal ───────────────────────────────────── */}
        <Modal
          isOpen={showCreateModal}
          toggle={() => this.setState({ showCreateModal: false, createError: null })}
          fade={false}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({ showCreateModal: false, createError: null })}>
            New Quantity Calculation Sheet
          </ModalHeader>

          <ModalBody>
            {/* Filter tabs */}
            <Nav tabs className="mb-3">
              <NavItem>
                <NavLink
                  className={activeTab === "all" ? "active" : ""}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    this.setState({ activeTab: "all", selectedBidItem: null })
                  }
                >
                  All Items
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "dow" ? "active" : ""}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    this.setState({ activeTab: "dow", selectedBidItem: null })
                  }
                >
                  By Division of Work
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "reportedItems" ? "active" : ""}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    this.setState({ activeTab: "reportedItems", selectedBidItem: null })
                  }
                >
                  Reported Items
                </NavLink>
              </NavItem>
            </Nav>

            {/* Division of Work sub-filter */}
            {activeTab === "dow" && (
              <div className="mb-3">
                <label className="col-form-label pr-3">
                  <small><b>Filter by:</b></small>
                </label>
                <ButtonGroup size="sm">
                  <Button
                    outline
                    color="secondary"
                    active={dowFilter === "roadway"}
                    onClick={() =>
                      this.setState({ dowFilter: "roadway", selectedBidItem: null })
                    }
                  >
                    Roadway
                  </Button>
                  <Button
                    outline
                    color="secondary"
                    active={dowFilter === "structure"}
                    onClick={() =>
                      this.setState({ dowFilter: "structure", selectedBidItem: null })
                    }
                  >
                    Structure
                  </Button>
                </ButtonGroup>
              </div>
            )}

            {/* Reported Items table (Reported Items tab) */}
            {activeTab === "reportedItems" && (
              <div style={{ maxHeight: "340px", overflowY: "auto" }} className="mb-1">
                {reportedItems.loading ? (
                  <div className="text-muted text-center p-3">Loading...</div>
                ) : reportedItems.items.length === 0 ? (
                  <div className="text-muted fst-italic p-2">
                    No accepted daily reports found for this pay period.
                  </div>
                ) : (
                  <table className="table table-sm table-bordered table-hover w-100 mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "60px" }}>Item #</th>
                        <th>Description</th>
                        <th style={{ width: "110px", textAlign: "right" }}>Report Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportedItems.items.map((item) => {
                        const isSelected = selectedBidItem?.value === item.bidItemId;
                        return (
                          <tr
                            key={item.bidItemId}
                            onClick={() =>
                              this.setState({
                                selectedBidItem: isSelected
                                  ? null
                                  : { value: item.bidItemId, label: `${item.itemCode} – ${item.description}` },
                              })
                            }
                            style={{ cursor: "pointer" }}
                            className={isSelected ? "table-primary" : ""}
                          >
                            <td>{item.itemNo}</td>
                            <td>{item.description}</td>
                            <td style={{ textAlign: "right" }}>{item.reportCount}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {/* Bid item selector — hidden when selecting via Reported Items table */}
            {activeTab !== "reportedItems" && (
              <div className="form-group row align-items-center mb-1">
                <label className="col-3 col-form-label">
                  <b>Bid Item:</b>
                </label>
                <div className="col-9">
                  <Select
                    options={bidItemOptions}
                    value={selectedBidItem}
                    onChange={(selected) =>
                      this.setState({ selectedBidItem: selected })
                    }
                    placeholder={projItemList ? "Select bid item..." : "Loading bid items..."}
                    isLoading={!projItemList}
                    isClearable
                  />
                </div>
              </div>
            )}
            {createError && (
              <div className="alert alert-danger mt-2 mb-0" role="alert">
                {createError}
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              color="secondary"
              outline
              onClick={() => this.setState({ showCreateModal: false, createError: null })}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={this.handleCreateSubmit}
              disabled={!selectedBidItem}
            >
              Create QSheet
            </Button>
          </ModalFooter>
        </Modal>

        {/* ── Estimate Detail (CEM-6101) Modal ─────────────────────── */}
        <EstimateDetailModal
          isOpen={showEstimateDetailModal}
          onClose={() => this.setState({ showEstimateDetailModal: false })}
          initialValues={estimateDetailValues}
          onSave={(values) => this.setState({ estimateDetailValues: values, showEstimateDetailModal: false })}
        />

        {/* ── Delete Confirmation Modal ─────────────────────────────── */}
        <AlertModal
          showAlertModal={!!pendingDeleteId}
          toggleAlertModal={this.handleDeleteAction("reject")}
          handleAlertAction={this.handleDeleteAction}
          alertTitle="Delete Q-Sheet"
          alertTitleClass="bg-danger text-white"
          alertTitleIcon="trash-alt"
          alertText={"Are you sure you want to delete this Q-Sheet? This cannot be undone."}
          acceptCaption="Delete"
          acceptClass="danger"
          provideReject={true}
          rejectCaption="Cancel"
          rejectClass="secondary"
        />

        {/* ── Close Estimate Confirmation Modal ─────────────────────── */}
        <AlertModal
          showAlertModal={showCloseConfirm}
          toggleAlertModal={this.handleCloseEstimateAction("reject")}
          handleAlertAction={this.handleCloseEstimateAction}
          alertTitle="Lock Pay Estimate"
          alertTitleClass="bg-success text-white"
          alertTitleIcon="lock"
          alertText={[
            qSheets.some((qs) => qs.isSubmitted)
              ? `Warning: This Estimate contains Q-Sheets that have not been checked yet.`
              : null,
            `Lock this Pay Estimate? This will close the estimate and lock all Q-Sheets. This cannot be undone.`,
          ].filter(Boolean).join("\n")}
          acceptCaption="Lock"
          acceptClass="success"
          provideReject={true}
          rejectCaption="Cancel"
          rejectClass="secondary"
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  estimateDetail: state.payEstimate.openEstimateDetails[ownProps.tab.tabId] || null,
  reportedItems: state.payEstimate.reportedItems[ownProps.tab.tabId] || { loading: false, items: [] },
  projItemList: state.bidItems.projItemLists[ownProps.tab.projectId] || null,
  userId: state.authentication.user?.userId,
  updating: state.payEstimate.updating,
  fetching: state.payEstimate.fetching,
  prepopulatingQSheets: state.payEstimate.prepopulatingQSheets[ownProps.tab.tabId] || false,
});

export default connect(mapStateToProps)(PayEstimateDetail);
